/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DevicePlanChangeAction {
    Upgrade = 'upgrade',
    Downgrade = 'downgrade'
}


export function instanceOfDevicePlanChangeAction(value: any): boolean {
    for (const key in DevicePlanChangeAction) {
        if (Object.prototype.hasOwnProperty.call(DevicePlanChangeAction, key)) {
            if (DevicePlanChangeAction[key as keyof typeof DevicePlanChangeAction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DevicePlanChangeActionFromJSON(json: any): DevicePlanChangeAction {
    return DevicePlanChangeActionFromJSONTyped(json, false);
}

export function DevicePlanChangeActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevicePlanChangeAction {
    return json as DevicePlanChangeAction;
}

export function DevicePlanChangeActionToJSON(value?: DevicePlanChangeAction | null): any {
    return value as any;
}

export function DevicePlanChangeActionToJSONTyped(value: any, ignoreDiscriminator: boolean): DevicePlanChangeAction {
    return value as DevicePlanChangeAction;
}

